import { configPortal } from "../../../../configPortal";
import { _single } from "../../../../core/services/dataBean/EntityCatalog"
import "./PortalFooter.css"

export const PortalFooterHomePage = () => {
    const now = new Date();
    const yy = now.getFullYear().toString().slice(-2);
    const MM = (now.getMonth() + 1).toString().padStart(2, '0');
    const dd = now.getDate().toString().padStart(2, '0');
    const name = configPortal.COMPANY_NAME ?? "Advantage Microsytems Colombia LTDA";

    return (

        <footer className="footer-container">
            <div className="right-container">
                <span>{`©${yy}-${MM}-${dd} ${name}`}</span>
            </div>
            <div className="left-container">
                <span>{`©Advantage Microsystems Colombia LTDA`}</span>
            </div>
        </footer>
    )
}